import React, { FC } from 'react';
import { SystemButtonDefault } from '../systemButtonDefaultProps';
import { SystemButtonProps } from '../button.types';
import styles from './text_button.module.scss';
import { BaseButton } from '../BaseButton';

export const TextButton: FC<SystemButtonProps> = ({
  dataName,
  children,
  ...rest
}) => {
  return (
    <BaseButton {...rest} className={styles.text} name={dataName}>
      <span className={styles.content}>{children}</span>
    </BaseButton>
  );
};

TextButton.defaultProps = SystemButtonDefault;
